/**
 * Store Provider
 * Provides Redux store to the app
 */

import { ReactNode } from 'react'
import { Provider } from '@ufc/core'
import { store } from '@/store'

interface StoreProviderProps {
  children: ReactNode
}

export function StoreProvider({ children }: StoreProviderProps) {
  return <Provider store={store}>{children}</Provider>
}
